<template>
  <div>
    <div class="modal hide fade" id="modalSalePaymentGroup" tabindex="-1" role="dialog" aria-labelledby="modalSalePaymentGroup" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
              <h4 class="modal-title">Sales List</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                  <div class="table-responsive">
                      <table class="table table-item table-sm table-hover table-striped">
                          <thead>
                            <th><label class="form-checkbox"><input type="checkbox" value="true" v-model="selectAll" @input="selectAllSales"><i class="form-icon"></i></label></th>
                            <th>Status</th>
                            <th>Type</th>
                            <th>Sale No.</th>
                            <th>Customer</th>
                            <th>Salesman</th>
                            <th>Date</th>
                            <th>Due Date</th>
                            <th>Discount</th>
                            <th>Tax</th>
                            <th class="text-right">Total</th>
                            <th class="text-right">Retur</th>
                            <th class="text-right">Deliver</th>
                            <th class="text-right">Total Payment</th>
                            <th class="text-right">Outstanding</th>
                          </thead>
                          <tbody>
                              <tr v-for="(d, index) in customerOutstandingList" :key="index">
                                  <td>
                                      <label class="form-checkbox" v-if="d.status === 'approved'">
                                        <input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i>
                                      </label>
                                  </td>
                                  <td>
                                      <span class="badge badge-primary" v-if="d.status === 'order'">{{ d.status }}</span>
                                      <span class="badge badge-success" v-else-if="d.status === 'approved'">{{ d.status }}</span>
                                      <span class="badge badge-warning" v-else>{{ d.status }}</span>
                                  </td>
                                  <td>{{ d.type }}</td>
                                  <td>{{ d.sale_no }}</td>
                                  <td><b>{{ d.customer }}</b></td>
                                  <td>{{ d.salesman }}</td>
                                  <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td>{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td>{{ d.discount | currency }}</td>
                                  <td>{{ d.tax | currency }}</td>
                                  <td class="text-right">{{ d.total | currency }}</td>
                                  <td class="text-right">{{ d.return_total | currency }}</td>
                                  <td class="text-right">{{ d.delivery_cost | currency }}</td>
                                  <td class="text-right">{{ d.payment_total | currency }}</td>
                                  <td class="text-right">{{ d.outstanding | currency }}</td>
                              </tr>
                              <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <!-- <pre>{{ customerOutstandingList }}</pre> -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
              <button class="btn btn-sm btn-hard-primary" data-dismiss="modal" @click="process">Process {{ totalProcess | currency }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- vendor outstanding -->
    <div class="modal hide fade" id="modalPurchasingPaymentGroup" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingPaymentGroup" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
              <h4 class="modal-title">Purchasing List</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                  <div class="table-responsive">
                      <table class="table table-item table-sm table-hover table-striped">
                          <thead>
                              <th><label class="form-checkbox"><input type="checkbox" value="true" v-model="selectAll" @input="selectAllPurchasing"><i class="form-icon"></i></label></th>
                              <th>Status</th>
                              <th>Sale No.</th>
                              <th>Customer</th>
                              <th>Date</th>
                              <th>Due Date</th>
                              <th class="text-right">Discount</th>
                              <th class="text-right">Tax</th>
                              <th class="text-right">Delivery Cost</th>
                              <th class="text-right">Total</th>
                              <th class="text-right">Retur</th>
                              <th class="text-right">Total Payment</th>
                              <th class="text-right">Outstanding</th>
                          </thead>
                          <tbody>
                              <tr v-for="(d, index) in vendorOutstandingList" :key="index">
                                  <td>
                                    <label class="form-checkbox" v-if="d.status === 'approve'">
                                      <input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i>
                                    </label>
                                  </td>
                                  <td>
                                      <span class="badge badge-success" v-if="d.status === 'order'">{{ d.status }}</span>
                                      <span class="badge badge-primary" v-else-if="d.status === 'approve'">{{ d.status }}</span>
                                      <span class="badge badge-warning" v-else>{{ d.status }}</span>
                                  </td>
                                  <td>{{ d.purchasing_no }}</td>
                                  <td><b>{{ d.vendor }}</b></td>
                                  <td>{{ d.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td>{{ d.purchasing_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td class="text-right">{{ d.discount | currency }}</td>
                                  <td class="text-right">{{ d.tax | currency }}</td>
                                  <td class="text-right">{{ d.delivery_cost | currency }}</td>
                                  <td class="text-right">{{ d.total | currency }}</td>
                                  <td class="text-right">{{ d.return_total | currency }}</td>
                                  <td class="text-right">{{ d.payment_total | currency }}</td>
                                  <td class="text-right">{{ d.outstanding | currency }}</td>
                              </tr>
                              <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
              <button class="btn btn-sm btn-hard-primary" data-dismiss="modal" @click="processVendor">Process {{ totalProcessVendor | currency }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SalePaymentGroupModal',
  computed: {
    ...mapState({
      customerOutstandingList: state => state.customers.customerOutstandingList,
      vendorOutstandingList: state => state.vendors.vendorOutstandingList
    }),
    totalProcessVendor () {
      var array = this.selected
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var vendor = this.vendorOutstandingList.find(d => d.id === array[i])
        if (vendor) {
          sum += parseFloat(vendor.outstanding)
        }
      }
      return sum
    },
    totalProcess () {
      var array = this.selected
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var customer = this.customerOutstandingList.find(d => d.id === array[i])
        if (customer) {
          sum += parseFloat(customer.outstanding)
        }
      }
      return sum
    },
    totalSalePaymentOutstanding () {
      var sum = 0
      var array = this.customerOutstandingList
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    }
  },
  data () {
    return {
      selectAll: false,
      selected: []
    }
  },
  methods: {
    async selectAllPurchasing () {
      if (this.selectAll === false) {
        var array = this.vendorOutstandingList
        for (let i = 0; i < array.length; i++) {
          this.selected.push(array[i].id)
        }
      } else {
        this.selected = []
        this.payment.purchasings = []
      }
    },
    async selectAllSales () {
      if (this.selectAll === false) {
        var array = this.customerOutstandingList
        for (let i = 0; i < array.length; i++) {
          this.selected.push(array[i].id)
        }
      } else {
        this.selected = []
        this.payment.sales = []
      }
    },
    async process () {
      var array = this.selected
      var data = []
      for (let i = 0; i < array.length; i++) {
        var obj = this.customerOutstandingList.find(d => d.id === array[i])
        if (obj) {
          data.push(obj)
        }
      }
      this.selected = []
      this.selectAll = false
      this.$emit('processPayment', data)
    },
    async processVendor () {
      var array = this.selected
      var data = []
      for (let i = 0; i < array.length; i++) {
        var vendor = this.vendorOutstandingList.find(d => d.id === array[i])
        var obj = {
          id: vendor.id,
          purchasing_no: vendor.purchasing_no,
          purchasing_date: vendor.purchasing_date,
          purchasing_due_date: vendor.purchasing_due_date,
          ref_no: vendor.ref_no,
          branch_no: vendor.branch_no,
          vendor_no: vendor.vendor_no,
          vendor: vendor.vendor,
          subtotal: vendor.subtotal,
          tax_id: vendor.tax_id,
          tax: vendor.tax,
          taxes: vendor.taxes,
          discount: vendor.discount,
          total: vendor.total,
          return_total: vendor.return_total,
          payment_total: vendor.payment_total,
          outstanding: vendor.outstanding.toFixed(2),
          delivery_cost: vendor.delivery_cost,
          deliver_no: vendor.deliver_no,
          status: vendor.status,
          type_id: vendor.type_id,
          lock: vendor.lock,
          company_no: vendor.company_no,
          term_due_id: vendor.term_due_id,
          ext_no: vendor.ext_no,
          sp_no: vendor.sp_no,
          discount_percentage: vendor.discount_percentage,
          schedule_payment_date: vendor.schedule_payment_date
        }
        data.push(obj)
      }
      this.selected = []
      this.selectAll = false
      this.$emit('processPaymentVendor', data)
    }
  }
}
</script>
